import React from "react";

const EventIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.3273,8.463v-1.972c0,-0.979 -0.7978,-1.777 -1.7771,-1.777c-0.9793,0 -1.7771,0.798 -1.7771,1.777v1.972h-4.9006v-1.972c0,-0.979 -0.7978,-1.777 -1.7771,-1.777c-0.9793,0 -1.7771,0.798 -1.7771,1.777v1.972h-3.4609v14.473c0,1.613 1.3128,2.926 2.9252,2.926h14.1314c1.6125,0 2.9252,-1.313 2.9252,-2.926v-14.473zM18.8284,6.487c0,-0.397 0.325,-0.722 0.7218,-0.722c0.3968,0 0.7218,0.325 0.7218,0.722v1.971h-1.4436zM10.3736,6.487c0,-0.397 0.325,-0.722 0.7218,-0.722c0.3968,0 0.7218,0.325 0.7218,0.722v1.971h-1.4436zM24.7797,22.936c0,1.03 -0.84,1.87 -1.8699,1.87h-14.1314c-1.0299,0 -1.8699,-0.84 -1.8699,-1.87v-13.418h4.9045v1.359c0,0.291 0.2364,0.528 0.5276,0.528c0.2913,0 0.5276,-0.237 0.5276,-0.528v-1.359h7.3996v1.359c0,0.291 0.2364,0.528 0.5276,0.528c0.2913,0 0.5277,-0.237 0.5277,-0.528v-1.359h3.4524v13.418z"
        fill="currentColor"
      />
      <path
        d="M20.4422,16.611l-2.1817,2.226l0.5849,2.943c0.0299,0.148 -0.1196,0.269 -0.2476,0.198l-1.584,-0.865l-1.0119,-0.547l-2.5958,1.416c-0.1281,0.072 -0.2775,-0.049 -0.2476,-0.197l0.5849,-2.943l-2.1902,-2.231c-0.1068,-0.108 -0.0427,-0.3 0.1024,-0.314l2.946,-0.255l1.2381,-2.934c0.0598,-0.144 0.2562,-0.144 0.3159,0l1.2382,2.938l2.9459,0.256c0.1494,0.013 0.2135,0.201 0.1025,0.313z"
        fill="currentColor"
      />
      <path
        d="M17.0091,21.113l-1.0119,-0.547l-2.5958,1.416c-0.1281,0.072 -0.2775,-0.049 -0.2476,-0.197l0.5849,-2.943l-2.186,-2.231c5.3923,-0.431 5.4564,4.502 5.4564,4.502z"
        fill="#1A8B5A"
      />
    </svg>
  );
};

export default EventIcon;
